/**
 * @overview Helpers for checkboxes.
 *
 * @module checkboxHelper
 */

import $ from 'qwery';
import { getInputByValue } from './domHelper';


/**
 * Checks whether a checkbox is checked.
 *
 * @param {string} checkbox
 * @returns {boolean}
 */
export const isChecked = (checkbox) => checkbox.checked;

/**
 * Checks whether any checkboxes are checked.
 *
 * @param {HTMLInputElement[]} checkboxes
 * @returns {boolean}
 */
export const areAnyCheckboxesChecked = (checkboxes) => checkboxes.some(isChecked);

/**
 * Get the checkbox values.
 *
 * @param {HTMLInputElement[]} checkboxes
 * @returns {string[]}
 */
export const getCheckboxValues = (checkboxes) => checkboxes.map(checkbox => checkbox.value);

/**
 * Unchecks every checkbox except the "All" checkbox.
 *
 * @param {HTMLInputElement[]} checkboxes
 * @returns {HTMLInputElement[]}
 */
export function checkSelectAllCheckbox (checkboxes) {
    return checkboxes.map(checkbox => {
        checkbox.checked = checkbox.value === 'all';
        return checkbox;
    });
}

/**
 * Unchecks every checkbox passed in.
 *
 * @param {HTMLInputElement[]} checkboxes to uncheck
 * @returns {HTMLInputElement[]}
 */
export function uncheckEveryCheckbox (context) {
    const checkboxes = $('input[type="checkbox"]', context);

    return checkboxes.map(checkbox => {
        checkbox.checked = false;
        return checkbox;
    });
}

/**
 * Check an input with matching value attribute.
 *
 * @param {string} value
 * @param {string|Node} context
 */
export function checkInputByValue (value, context) {
    const input = getInputByValue(value, context);

    if (input && (input.type === 'checkbox' || input.type === 'radio')) {
        input.checked = true;
        return input;
    }

    return null;
}

/**
 * Check all inputs with matching value attributes.
 *
 * @param {string[]} values
 * @param {string|Node} context
 */
export function checkInputsByValue (values, context) {
    if (Array.isArray(values)) {
        return values
            .map(checkbox => checkInputByValue(checkbox, context))
            .filter(checkbox => checkbox != null);
    }

    return checkInputByValue(values, context);
}

/**
 * Checks the "all" checkbox if no other checkbox in the context is selected, and unchecks it if another is selected.
 *
 * @param {string} value
 * @param {string|Node} context
 */
export function selectAllCheckboxActions (value, { context, allValue = 'all' } = {}) {
    const checkboxCssSelector = 'input[type="checkbox"]';
    const checkboxes = $(checkboxCssSelector, context);
    const selectAllCheckbox = $(`${checkboxCssSelector}[value=${allValue}]`, context)[0];

    if (value === allValue) {
        uncheckEveryCheckbox(context);
    }

    // Select `all` checkbox if no other checkboxes are selected
    if (selectAllCheckbox) {
        selectAllCheckbox.checked = !areAnyCheckboxesChecked(checkboxes);
    }
}
